import React, { useContext, createRef, useEffect, useRef } from "react";
import "ui/UI.css";
import DatabaseContext from "data/contextDatabase";
import GlobalContext from "contexts/context";
import { useLiveMessages } from "hooks/dbHooks";
import UIMessageSend from "ui/UIMessageSend";
import UIMessage from "ui/UIMessage";
import UIPeerStream from "ui/UIPeerStream";

require("intersection-observer");

//let autoScroll = false;

const UIMessageList = (props) => {
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const { globalState, globalDispatch } = useContext(GlobalContext);
  const liveMessages = useLiveMessages(
    databaseState.dbMaster,
    props.location.state,
    props.location.state.subscription?.mtopic ??
      props.location.state.dialog?.mdialog,
    200
  );

  const firstUnread = useRef(null);
  const lastRef = useRef(null);
  const autoScroll = useRef(false);

  const liveSorted = [...liveMessages];

  const refs = liveSorted.reduce((acc, m) => {
    acc[m.msgid + "-" + m.msg_idx] = createRef();
    lastRef.current = m.msgid + "-" + m.msg_idx;
    if (!m.read && !firstUnread.current) {
      firstUnread.current = { ref: m.msgid + "-" + m.msg_idx, used: false };
      console.log("firstUnread ", m);
    }
    return acc;
  }, {});

  const onChange = (changes, observer) => {
    changes.forEach((change) => {
      if (change.isIntersecting) {
        autoScroll.current = true;
      } else {
        autoScroll.current = false;
      }
    });
  };

  let options = {
    root: document.getElementById("message-list"),
    rootMargin: "0px",
    thresholds: [0],
  };

  let observer = new IntersectionObserver(onChange, options);

  const onRead = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let table =
          props.location.state.subscription?.mtopic ??
          props.location.state.dialog?.mdialog;
        if (entry.target.getAttribute("isread") === "false" && table) {
          let smid = entry.target.getAttribute("smid");

          liveSorted[entry.target.getAttribute("idx")].read = true;

          databaseDispatch({
            type: "MARK_READ",
            values: {
              db: databaseState.dbMaster,
              collection: "messages",
              table: table,
              rowid: smid,
            },
          });
        }
      }
    });
  };

  let optionsRead = {
    root: document.getElementById("message-list"),
    rootMargin: "0px",
    threshold: 0.5,
  };

  let observerRead = new IntersectionObserver(onRead, optionsRead);

  useEffect(() => {
    // Set current dialog (used for determining notifications)
    globalDispatch({
      type: "SET_CURRENT_TOPIC",
      values: {
        displaying_topic:
          props.location.state.subscription?.mtopic ??
          props.location.state.dialog?.mdialog,
      },
    });
    return () => {
      // Reset current dialog to undefined
      globalDispatch({
        type: "SET_CURRENT_TOPIC",
        values: { displaying_topic: undefined },
      });
    };
  }, [
    globalDispatch,
    props.location.state.subscription,
    props.location.state.dialog,
    JSON.stringify(props.location.state.subscription),
    JSON.stringify(props.location.state.dialog),
  ]);

  useEffect(() => {
    // This runs after component is rendered ... first time. The [] indicates "no dependencies"
    // so this is like componentDidMount

    if (lastRef.current && !firstUnread.current?.used) {
      if (!firstUnread.current) {
        firstUnread.current = { ref: lastRef.current, used: false };
      }

      refs[firstUnread.current.ref].current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      firstUnread.current.used = true;
      console.log("Scrolling to last read ", firstUnread.current);
    }
    return () => {};
  }, [refs]);

  useEffect(() => {
    if (refs && lastRef.current && autoScroll.current) {
      refs[lastRef.current]?.current &&
        refs[lastRef.current].current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }
    console.log("lastRef.current ", lastRef.current);
    refs &&
      lastRef.current &&
      document.getElementById(lastRef.current) &&
      observer.observe(document.getElementById(lastRef.current));
    lastRef.current &&
      document.getElementById(lastRef.current) &&
      console.log(
        "position: ",
        document.getElementById(lastRef.current).getBoundingClientRect()
      );
    return () => {
      observer.disconnect();
    };
  }, [observer, refs]);

  useEffect(() => {
    if (refs) {
      // Our ref has a value, pointing to an HTML element
      // The perfect time to observe it.

      // console.log("ref: refs ", Object.entries(refs));

      Object.entries(refs).forEach(([key, value]) => {
        if (value?.current) {
          // console.log("ref: ", value);
          observerRead.observe(value.current);
        }
      });
    }

    return () => {
      if (refs) {
        // We need to clean up after this ref
        // The perfect time to unobserve it.
        observerRead.disconnect();
      }
    };
  }, [observerRead, refs]);

  // if props.location.state is undefined, then go to topic selection page
  if (props.location.state === undefined) {
    props.history.push("/");
    return null;
  }

  let messageList = (
    <div className="UI-message-list-container">
      <div className="UI-message-list" id="message-list">
        {liveSorted === undefined ? (
          <p></p>
        ) : (
          // List is reversed, display is twice rotated by 180deg to avoid scroll on opening
          // so we are displaying the list inverted ;-)
          // liveSorted.reverse().map((m, i, a) => {
          liveSorted.map((m, i, a) => {
            return (
              <div
                ref={refs[m.msgid + "-" + m.msg_idx]}
                key={m.msgid + "-" + m.msg_idx}
                id={m.msgid + "-" + m.msg_idx}
                smid={m.smid}
                isread={m.read ? "true" : "false"}
                idx={i}
                // style={{
                //   transform: "rotate(180deg)",
                // }}
              >
                <UIMessage
                  message={m}
                  muid={globalState.muid}
                  you={
                    props.location.state.dialog === undefined
                      ? props.location.state.subscription.mpersona
                      : props.location.state.dialog.mpersona
                  }
                  persona={
                    props.location.state.dialog === undefined
                      ? props.location.state.subscription.persona
                      : props.location.state.dialog.persona
                  }
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );

  let messageSend;
  let label;
  if (props.location.state.dialog === undefined) {
    label =
      props.location.state.subscription.topic_display_name ||
      props.location.state.subscription.topic;
    messageSend =
      props.location.state.subscription.got_voice === "true" ? (
        <UIMessageSend
          mtopic={props.location.state.subscription.mtopic}
          topic={props.location.state.subscription.topic}
          persona={props.location.state.subscription.persona}
          mpersona={props.location.state.subscription.mpersona}
          name={props.location.state.subscription.persona}
          topic_display_name={
            props.location.state.subscription.topic_display_name || ""
          }
        />
      ) : (
        <div />
      );
  } else {
    let marray = props.location.state.dialog.mdialog.split("/");
    let tag = marray.length === 2 ? marray[1] : "";
    let topic_display_name =
      props.location.state.dialog.dialog !==
        props.location.state.dialog.persona &&
      props.location.state.dialog.dialog !==
        props.location.state.dialog.peerpersona
        ? props.location.state.dialog.dialog
        : "";
    label =
      props.location.state.dialog.topic_display_name ||
      props.location.state.dialog.dialog;
    messageSend = props.location.state.dialog.got_voice ? (
      <UIMessageSend
        mdialog={props.location.state.dialog.mdialog}
        dialog={props.location.state.dialog.dialog}
        persona={props.location.state.dialog.persona}
        mpersona={props.location.state.dialog.mpersona}
        name={props.location.state.dialog.persona}
        peer={props.location.state.dialog.peer}
        tag={tag}
        topic_display_name={topic_display_name}
      />
    ) : (
      <div />
    );
  }

  let vidFrame = (
    <UIPeerStream
      mpersona={props.location.state.dialog?.mpersona}
      peermpersona={props.location.state.dialog?.peer}
    />
  );

  let content = (
    <div className="UI">
      <div className="UI-unread-topics-container">
        <label className="UI-unread-topics">Unread topics</label>
        <label className="UI-unread-topics">
          {databaseState.liveCount &&
            Object.entries(databaseState.liveCount).reduce((r, a) => {
              return r + (a[1] > 0 ? 1 : 0);
            }, 0)}
        </label>
        <label className="UI-unread-topics">
          {databaseState.liveCount &&
            "(" +
              Object.entries(databaseState.liveCount).reduce((r, a) => {
                return r + (a[1] > 0 ? a[1] : 0);
              }, 0) +
              " messages)"}
        </label>
      </div>
      <label>
        <b>{label}</b>
      </label>
      {props.location.state.dialog &&
        (props.location.state.dialog.peerpersona === "dbl.test.120" ||
          props.location.state.dialog.persona === "dbl.test.120") &&
        vidFrame}
      {messageList}
      {messageSend}
    </div>
  );

  return content;
};

export default React.memo(UIMessageList, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
